@if (_elements.length > 0) {
  <div class="dics-container">
    <ddc-dic-s
      class="word-dic-element"
      *ngFor="let element of _elements | slice: 0 : 3"
      matTooltip="Dictionary"
      [label]="element.title"
    ></ddc-dic-s>
  </div>
}
